export const CheckCircledFilledIcon = (
  props: React.SVGProps<SVGSVGElement>
) => (
  <svg width="15" height="15" viewBox="0 0 16 16" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.35205 7.99988C1.35205 4.32839 4.32839 1.35205 7.99988 1.35205C11.6713 1.35205 14.6477 4.32839 14.6477 7.99988C14.6477 11.6713 11.6713 14.6477 7.99988 14.6477C4.32839 14.6477 1.35205 11.6713 1.35205 7.99988ZM10.5377 5.3411C10.7636 5.50001 10.8178 5.81192 10.6589 6.03775L7.49224 10.5377C7.40684 10.6591 7.27194 10.7363 7.12404 10.7483C6.97614 10.7604 6.83052 10.7062 6.72655 10.6003L5.14322 8.98766C4.94976 8.79062 4.95266 8.47405 5.1497 8.28058C5.34675 8.08712 5.66332 8.09002 5.85678 8.28707L7.01974 9.47155L9.8411 5.46225C10 5.23642 10.3119 5.18218 10.5377 5.3411Z"
      fill="currentColor"
    />
  </svg>
)
